import { useContext } from "react";
import VspPortalContext from "../../store/VspPortalContext";
import { NotificationTypes } from "../../enums/NotificationTypes";
import { CardholderAccessGroupDto } from "../../dtos/CardholderAccessGroupDto";
import { HttpMethods } from "../../enums/HttpMethods";
import { VspPortalActions } from "../../store/VspPortalActions";
import { useVspPortalHttp } from "../../hooks/useVspPortalHttp";


export type CardholderAccessGroupResponse = {
    
    cardholderAccessGroupDtos: CardholderAccessGroupDto[] | null;
    statusCode: number | null;

}


export const useManageAccessHttp = ( ): {
    
    addCardholderAccessGroup( accessGroup: string, employeeId: string, securityRoleIds: string[ ], until: string | undefined, villageCode: string ): Promise<boolean>
    , getCardholderCommonAreaAccessGroups( employeeId: string, securityRoleIds: string[ ], villageCode: string ): Promise<CardholderAccessGroupResponse>
    , removeCardholderAccessGroup( accessGroup: string, employeeId: string, securityRoleIds: string[ ], villageCode: string ): Promise<boolean>

} => {

    const { dispatch } = useContext( VspPortalContext );
    const { fetchData, getHttpOptions } = useVspPortalHttp( );

    const addCardholderAccessGroup = async( accessGroup: string, employeeId: string, securityRoleIds: string[ ], until: string | undefined, villageCode: string ): Promise<boolean> => {

        const requestBody = [
            {
              "op": "add",
              path: "accessGroup",
              "value": 
              {
                "AccessGroup": accessGroup,
                "Until": until
              }
            }
        ];

        
        const options = await getHttpOptions ( HttpMethods.Patch, JSON.stringify( requestBody ) );

        const query = `${process.env.REACT_APP_API_URL}/cardholderAccessGroup?employeeId=${employeeId}&villageCode=${villageCode}&securityRoleId=` + securityRoleIds.join( '&securityRoleId=' );

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error adding cardholder access' });
            return false;

        }

        dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Success });
        dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Cardholder access successfully added' });

        return true;

    };


    const getCardholderCommonAreaAccessGroups = async ( employeeId: string, securityRoleIds: string[ ], villageCode: string ): Promise<CardholderAccessGroupResponse> => {

        
        const options = await getHttpOptions ( HttpMethods.Get, undefined );

        const query = `${process.env.REACT_APP_API_URL}/cardholderAccessGroup?employeeId=${employeeId}&villageCode=${villageCode}&securityRoleId=` + securityRoleIds.join( '&securityRoleId=' );

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: `Error getting cardholder access for ${villageCode}` });

            return {

                cardholderAccessGroupDtos: null,
                statusCode: null

            };

        }

        if ( response.statusCode === 200 ) {
        
            return {
                
                cardholderAccessGroupDtos: await response.response?.json( ),
                statusCode: 200
            }

        }

        return {

            cardholderAccessGroupDtos: null,
            statusCode: response.statusCode

        };

    };


    const removeCardholderAccessGroup = async ( accessGroup: string, employeeId: string, securityRoleIds: string[ ], villageCode: string ): Promise<boolean> => {

        const requestBody = [
            {
                op: "remove",
                path: "accessGroup",
                value: 
                {
                    AccessGroup: accessGroup
                }
            }
        ];

        
        const options = await getHttpOptions ( HttpMethods.Patch, JSON.stringify( requestBody ) );

        const query = `${process.env.REACT_APP_API_URL}/cardholderAccessGroup?employeeId=${employeeId}&villageCode=${villageCode}&securityRoleId=` + securityRoleIds.join( '&securityRoleId=' );

        const response = await fetchData( options, query  );

        if ( response == null ) {

            dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Error });
            dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Error removing cardholder access' });

            return false;

        }

        dispatch({ type: VspPortalActions.SetNotificationType, payload: NotificationTypes.Success });
        dispatch({ type: VspPortalActions.SetNotificationText, payload: 'Cardholder access successfully removed' });

        return true;

    };


    return { addCardholderAccessGroup, getCardholderCommonAreaAccessGroups, removeCardholderAccessGroup };

};
